import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { billingNavigation, compactNavigation, defaultNavigation, futuristicNavigation, horizontalNavigation, operationsNavigation, partnerAdminNavigation, relationshipManagerNavigation, underwritingNavigation } from 'app/mock-api/common/navigation/data';

@Injectable({
    providedIn: 'root'
})
export class NavigationMockApi
{
    private readonly _compactNavigation: FuseNavigationItem[] = compactNavigation;
    private readonly _defaultNavigation: FuseNavigationItem[] = defaultNavigation;
    private readonly _futuristicNavigation: FuseNavigationItem[] = futuristicNavigation;
    private readonly _horizontalNavigation: FuseNavigationItem[] = horizontalNavigation;
    private readonly _relationshipManagerNavigation: FuseNavigationItem[] = relationshipManagerNavigation;
    private readonly _underwritingNavigation: FuseNavigationItem[] = underwritingNavigation;
    private readonly _operationsNavigation: FuseNavigationItem[] = operationsNavigation;
    private readonly _partnerAdminNavigation: FuseNavigationItem[] = partnerAdminNavigation;
    private readonly _billingNavigation: FuseNavigationItem[] = billingNavigation;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void
    {
        // -----------------------------------------------------------------------------------------------------
        // @ Navigation - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/common/navigation')
            .reply(() => {

                // Fill compact navigation children using the default navigation
                this._compactNavigation.forEach((compactNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === compactNavItem.id )
                        {
                            compactNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill futuristic navigation children using the default navigation
                this._futuristicNavigation.forEach((futuristicNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === futuristicNavItem.id )
                        {
                            futuristicNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill horizontal navigation children using the default navigation
                this._horizontalNavigation.forEach((horizontalNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === horizontalNavItem.id )
                        {
                            horizontalNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill relationship manager navigation children using the default navigation
                this._relationshipManagerNavigation.forEach((relationshipManagerNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === relationshipManagerNavItem.id )
                        {
                            //relationshipManagerNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill underwriting navigation children using the default navigation
                this._underwritingNavigation.forEach((underwritingNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === underwritingNavItem.id )
                        {
                            underwritingNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill operations navigation children using the default navigation
                this._operationsNavigation.forEach((operationsNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === operationsNavItem.id )
                        {
                            operationsNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill Partner Admin navigation children using the default navigation
                this._partnerAdminNavigation.forEach((operationsNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === operationsNavItem.id )
                        {
                            operationsNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Fill Partner Admin navigation children using the default navigation
                this._billingNavigation.forEach((operationsNavItem) => {
                    this._defaultNavigation.forEach((defaultNavItem) => {
                        if ( defaultNavItem.id === operationsNavItem.id )
                        {
                            operationsNavItem.children = cloneDeep(defaultNavItem.children);
                        }
                    });
                });

                // Return the response
                return [
                    200,
                    {
                        compact   : cloneDeep(this._compactNavigation),
                        default   : cloneDeep(this._defaultNavigation),
                        futuristic: cloneDeep(this._futuristicNavigation),
                        horizontal: cloneDeep(this._horizontalNavigation),
                        relationshipManager: cloneDeep(this._relationshipManagerNavigation),
                        underwriting: cloneDeep(this._underwritingNavigation),
                        operations: cloneDeep(this._operationsNavigation),
                        partnerAdmin: cloneDeep(this._partnerAdminNavigation),
                        billing: cloneDeep(this._billingNavigation)
                    }
                ];
            });
    }
}
